<template>
<div>
        <voice-feel-home postTitle="How does your voice feel today?" v-bind:postFeelings="[{  text: 'Very Poor', btncolor: 'red',btnicon: 'face' },{ text: 'Poor', btncolor: 'orange',  btnicon: 'face'},{ text: 'Fair', btncolor: 'yellow darken-2',btnicon: 'face'},{  text: 'Good',btncolor: 'light-green', btnicon: 'face' },{ text: 'Excellent',btncolor: 'green',btnicon: 'face' },]"></voice-feel-home>
        <div class="mb-4" id="my-voice-feel-home"></div>
        <vocal-activity-home></vocal-activity-home>
        <div class="mb-4" id="my-vocal-activity-home"></div>
        <vocal-naps-home></vocal-naps-home>
        <div class="mb-4" id="my-vocal-naps-home"></div>
        <water-consumption-home></water-consumption-home>
        <div class="mb-4" id="my-water-consumption-home"></div>
        <voice-calendar-stats></voice-calendar-stats>
        <div class="mb-4" id="my-voice-calendar-stats"></div>
</div>
</template>

<script>
import VoiceFeelHome from './home/VoiceFeelHome.vue'
import VocalActivityHome from './home/VocalActivityHome.vue'
import VocalNapsHome from './home/VocalNapsHome.vue'
import WaterConsumptionHome from './home/WaterConsumptionHome.vue'
import VoiceCalendarStats from './stats/CalendarStats.vue'
export default {
  data () {
    return {
      msg: 'Good Morning - This is the Home page!'
    }
  },
  components: {
            'voice-feel-home': VoiceFeelHome,
            'vocal-activity-home': VocalActivityHome,
            'vocal-naps-home': VocalNapsHome,
            'water-consumption-home': WaterConsumptionHome,
            'voice-calendar-stats': VoiceCalendarStats
  },
  mounted: function() {
    document.getElementById("my-voice-feel-home").insertAdjacentHTML('beforeend', "<div><strong>COMPONENT: VoiceFeelHome</strong><br><strong>PROPS</strong>: postTitle, postFeelings <br><strong>CODE</strong>:<<span>voice-feel-home</span> postTitle='' v-bind:postFeelings='[{  text: 'Very Poor', btncolor: 'red', btnicon: 'face' }]'><<span>/voice-feel-home</span>> </div>");
    document.getElementById("my-vocal-activity-home").insertAdjacentHTML('beforeend', "<div><strong>COMPONENT: VocalActivityHome</strong><br><strong>PROPS</strong>: <br><strong>CODE</strong>:<<span>vocal-activity-home</span>><<span>/vocal-activity-home</span>> </div>");
    document.getElementById("my-vocal-naps-home").insertAdjacentHTML('beforeend', "<div><strong>COMPONENT: VocalNapsHome</strong><br><strong>PROPS</strong>:  <br><strong>CODE</strong>:<<span>vocal-naps-home</span>><<span>/vocal-naps-home</span>> </div>");
    document.getElementById("my-water-consumption-home").insertAdjacentHTML('beforeend', "<div><strong>COMPONENT: WaterConsumptionHome</strong><br><strong>PROPS</strong>: <br><strong>CODE</strong>:<<span>water-consumption-home</span>><<span>/water-consumption-home</span>> </div>");
    document.getElementById("my-voice-calendar-stats").insertAdjacentHTML('beforeend', "<div><strong>COMPONENT: VoiceCalendarStats</strong><br><strong>PROPS</strong>:  <br><strong>CODE</strong>:<<span>voice-calendar-stats</span>><<span>/voice-calendar-stats</span>> </div>");

  }
}


</script>


// WEBPACK FOOTER //
// src/components/Dev.vue